import _ from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { resetToInitialState } from '~/reducers/common-actions';

export const wiseHQCoordinates = {
    lat: 42.3884516,
    lng: -71.1343216
};

export const lastPlanMapCenterSlice = createSlice({
    name: 'lastPlanMapCenter',
    // wiseSystems HQ until user starts panning plan map
    initialState: wiseHQCoordinates,
    reducers: {
        setLastPlanMapCenter: (state, action) => {
            const isObject = _.isObject(action.payload);
            const hasLatLng =
                Object.prototype.hasOwnProperty.call(action.payload, 'lat') &&
                Object.prototype.hasOwnProperty.call(action.payload, 'lng');
            if (isObject && hasLatLng) {
                return {
                    lat: action.payload.lat,
                    lng: action.payload.lng
                };
            }
            return state;
        },
        resetLastPlanMapCenter: () => {
            return wiseHQCoordinates;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetToInitialState, () => {
            return wiseHQCoordinates;
        });
    }
});

export const { setLastPlanMapCenter, resetLastPlanMapCenter } =
    lastPlanMapCenterSlice.actions;
export const selectLastPlanMapCenter = (state) => state.lastPlanMapCenter;
export default lastPlanMapCenterSlice.reducer;
